import { render, staticRenderFns } from "./Kpis.vue?vue&type=template&id=383a4fb6&scoped=true&"
import script from "./Kpis.vue?vue&type=script&lang=js&"
export * from "./Kpis.vue?vue&type=script&lang=js&"
import style0 from "./Kpis.vue?vue&type=style&index=0&id=383a4fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a4fb6",
  null
  
)

export default component.exports